import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormaDePagamento} from "../objetos/FormaDePagamento";
import {Pagamento} from "../objetos/Pagamento";
import {ControlContainer, NgForm} from "@angular/forms";
import {DescontoFormaPagamento} from '../../../../server/domain/DescontoFormaPagamento';

@Component({
  selector: 'app-grid-pagamento',
  templateUrl: './grid-pagamento.component.html',
  styleUrls: ['./grid-pagamento.component.scss'],
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})
export class GridPagamentoComponent implements OnInit {
  @Input()  formasDePagamento = [];
  @Input() totalPagar = 0;
  @Input() totalProdutos = 0;
  @Input() itens = [];
  pagamentos = [];
  @Output() mudouFormaPagamento = new EventEmitter();
  @Output() alterouOpcaoMultiplasFormas = new EventEmitter();
  multiplasFormasPagamentos = false;
  @Input() frm: NgForm;
  @Input() pagamentoComanda = false;
  @Input() modoPdv = false;
  @Input() pixOnlineTunaForma: any;
  @Input() pixOnlineTunaGerado: any;
  @Output() gerarPixOnlineTuna = new EventEmitter();
  public selectableSettings: any = {
    checkboxOnly: false,
    mode: 'single',
    drag: false,
  };
  public mySelection: number[] = [];
  public formaDePagamentoEscolhida: any = {
    id: null,
    descricao: ``,
    valor: 0.0,
    trocoPara: 0
  };
  msgErroAdicionar = '';
  pagamentoEmEdicao: any;
  troco = 0;
  trocoPara = 0;
  temTroco =  'nao';

  constructor() { }

  ngOnInit(): void {
    if (this.modoPdv) {
      this.multiplasFormasPagamentos = true;
    }
  }

  exibeDesconto(forma: FormaDePagamento): boolean {
    return !(this.pagamentoComanda && DescontoFormaPagamento.porProduto(forma)) &&
      DescontoFormaPagamento.deveExibirDesconto(forma, this.itens);
  }

  pagamentoBloqueadoPorPixOnline() {
    return this.pixOnlineTunaGerado != null;
  }

  selecionouForma($evento) {
    this.pagamentoFoiSelecionado($evento.selectedRows[0].dataItem);
  }

  pagamentoFoiSelecionado(formaDePagamentoEscolhida: any) {
    if(this.pagamentoBloqueadoPorPixOnline()) return;

    this.formaDePagamentoEscolhida = formaDePagamentoEscolhida;
    this.temTroco = 'nao';
    this.trocoPara = 0;

    let pagamentoSelecionado = this.obtenhaPagamentoSelecionado(this.formaDePagamentoEscolhida);

    if( pagamentoSelecionado )
      this.editarPagamento(pagamentoSelecionado)
    else{
      this.formaDePagamentoEscolhida.valor = this.obtenhaValorRestante()
    }

  }

  selecionouPixOnlineTuna() {
    if(this.pagamentoBloqueadoPorPixOnline()) return;

    this.formaDePagamentoEscolhida = this.pixOnlineTunaForma;
    this.mySelection = [];
    this.pagamentos = [];
    this.mudouFormaPagamento.emit();
  }

  pixOnlineTunaSelecionado() {
    return this.pixOnlineTunaForma && this.formaDePagamentoEscolhida &&
      this.formaDePagamentoEscolhida.id === this.pixOnlineTunaForma.id;
  }

  emitaGerarPixOnlineTuna() {
    this.gerarPixOnlineTuna.emit({});
  }

  obtenhaPagamentoSelecionado(formaDePagamento: FormaDePagamento) {
    for( let pagamento of this.pagamentos ) {
      if( pagamento.formaDePagamento.id === formaDePagamento.id ) {
        return pagamento;
      }
    }

    return null;
  }

  editarPagamento(pagamento: any) {
    delete this.msgErroAdicionar;
    this.pagamentoEmEdicao = Object.assign({}, pagamento);
    this.formaDePagamentoEscolhida = this.formasDePagamento.find((item: any) => item.id === pagamento.formaDePagamento.id)


    if(pagamento.id)
      this.formaDePagamentoEscolhida.valor = pagamento.trocoPara ?  pagamento.trocoPara  : pagamento.valor;

    this.mySelection = [this.formaDePagamentoEscolhida.id];
    this.calculeTroco();
  }

  removaPagamento(pagamento: any) {

    if(pagamento.id) {
      pagamento.removido = true
      pagamento.valorRemovido =    pagamento.valor ;
      pagamento.valor = 0;
      pagamento.trocoPara = 0;
      pagamento.desconto = 0;
      pagamento.taxa = 0;
    }
    else {
      let indicePagamento: number;

      for(let i = 0; i < this.pagamentos.length; i++)
        if(this.pagamentos[i].formaDePagamento.id === pagamento.formaDePagamento.id )
          indicePagamento = i;

      if(indicePagamento >= 0) this.pagamentos.splice(indicePagamento, 1);
    }
  }


  desremoverPagamento(pagamento: any){
    if(pagamento.valorRemovido <= this.obtenhaValorRestanteAhPagar()){
      pagamento.removido = false;
      pagamento.valor  = pagamento.valorRemovido;
    }

  }

  adicionePagamentoUnico() {
    if(this.pagamentoBloqueadoPorPixOnline()) return;

    let pagamento = this.obtenhaPagamentoUnico();

    if(!pagamento){
      pagamento = new Pagamento()
      this.pagamentos.push(pagamento)
    }

    delete pagamento.removido;
    pagamento.valor = this.totalPagar;
    pagamento.taxa = 0;
    pagamento.formaDePagamento = this.formaDePagamentoEscolhida;

    if( this.formaDePagamentoEscolhida.taxaCobranca)
      pagamento.setValorComTaxa(this.formaDePagamentoEscolhida.taxaCobranca)

    if(!this.pagarEmDinheiro())
      pagamento.trocoPara = 0;

    this.calculeTroco();
    this.mudouFormaPagamento.emit();
  }

  adicioneFormaDePagamento() {
    if(this.pagamentoBloqueadoPorPixOnline()) return;

    this.msgErroAdicionar = '';
    if( !this.formaDePagamentoEscolhida.id ) {
      this.msgErroAdicionar = 'Selecione uma forma de pagamento ';
      return;
    }

    if(this.formaDePagamentoEscolhida.online){
      this.msgErroAdicionar = 'Pagamento online deve ser usado como forma única.';
      return;
    }

    let pagamento: any =
      this.obtenhaPagamentoSelecionado(this.formaDePagamentoEscolhida);
    const valorAPagar = this.obtenhaValorRestanteAhPagar(pagamento);

    if(!pagamento && valorAPagar === 0 ) {
      this.msgErroAdicionar = 'Pedido já tem valor suficiente para ser pago.';
      return;
    }

    if( !this.formaDePagamentoEscolhida.valor || this.formaDePagamentoEscolhida.valor <= 0.0 ){
      if(!this.pagamentoEmEdicao || !this.pagamentoEmEdicao.id){
        this.msgErroAdicionar = 'Valor do pagamento está inválido: ' + this.formaDePagamentoEscolhida.valor
        return;
      }
    }

    if(!pagamento){
      pagamento =  new Pagamento();
      this.pagamentos.push(pagamento)
    } else {
      delete  pagamento.removido;
    }

    pagamento.formaDePagamento = this.formaDePagamentoEscolhida;

    //por equanto multipagametno sem desconto
    //if(pagamento.formaDePagamento && pagamento.formaDePagamento.possuiDesconto ){
     //  let valorDesconto = Math.min(this.formaDePagamentoEscolhida.valor, this.totalProdutos);

     //  pagamento.desconto = Number(( valorDesconto * (pagamento.formaDePagamento.desconto / 100)).toFixed(2))
   // }


    if(this.pagarEmDinheiro()){
      pagamento.trocoPara = this.formaDePagamentoEscolhida.valor;
      pagamento.valor =  this.formaDePagamentoEscolhida.valor > valorAPagar ? valorAPagar :  this.formaDePagamentoEscolhida.valor;
    } else {
      pagamento.valor = this.formaDePagamentoEscolhida.valor;

      if(pagamento.valor > valorAPagar  ) {
        this.msgErroAdicionar = 'Valor não pode ser maior do que valor restante (R$ ' +
          valorAPagar.toFixed(2) + ')';

        return;
      }
    }

    let taxaCobranca = this.formaDePagamentoEscolhida.taxaCobranca;

    if(taxaCobranca)
      pagamento.setValorComTaxa(taxaCobranca)

    this.deseslecionePagamento();
  }



  removaPagamentos(){
    if(this.pagamentoBloqueadoPorPixOnline()) return;

    this.pagamentos = this.pagamentos.filter((item: any) => item.id);

    this.pagamentos.forEach((pagamento: any) => {
      this.removaPagamento(pagamento)
    })
  }

  limpePagamentos(){
    this.removaPagamentos();
    this.deseslecionePagamento();
  }

  deseslecionePagamento(){
    if(this.pagamentoBloqueadoPorPixOnline()) return;

    delete this.formaDePagamentoEscolhida;
    delete  this.pagamentoEmEdicao;
    this.mySelection = []
    this.formaDePagamentoEscolhida = {
      id: null,
      descricao: ``,
      valor: 0.0,
      trocoPara: 0
    };
  }

  temFormaDePagamento(pagamento: Pagamento) {
    let indicePagamento: number;

    for(let i = 0; i < this.pagamentos.length; i++)
      if(this.pagamentos[i].formaDePagamento.id === pagamento.formaDePagamento.id ||
        (pagamento.id && this.pagamentos[i].id === pagamento.id))
        indicePagamento = i;


    return indicePagamento >= 0;

  }



  obtenhaValorRestante(){
    let pagamento = this.pagamentoEmEdicao ||
      this.obtenhaPagamentoSelecionado(this.formaDePagamentoEscolhida);

    let valorAPagar = this.obtenhaValorRestanteAhPagar(pagamento);

    return Number(valorAPagar.toFixed(2));
  }

  obtenhaValorRestanteAhPagar(pagamentoEditando: any = null) {
    let valor = this.totalPagar

    let totalPago = 0.0;
    for(let pagamento of this.pagamentos) {
      if(pagamento.removido) continue;
      if(!pagamentoEditando || pagamentoEditando.id !== pagamento.id  ){
        totalPago += pagamento.valor;
        if(pagamento.taxa) totalPago -= pagamento.taxa
      }

    }

    valor -= totalPago;

    if( valor < 0 ) {
      valor = 0;
    }

    return Number(valor.toFixed(2));
  }

  pagarEmDinheiro(){
    return this.formaDePagamentoEscolhida && this.formaDePagamentoEscolhida.nome === 'dinheiro'
  }

  ehPixOnline(formaDePagamento: any): boolean {
    return !!(formaDePagamento && formaDePagamento.online && formaDePagamento.pix);
  }

  ehCartaoOnline(formaDePagamento: any): boolean {
    return !!(formaDePagamento && formaDePagamento.online && !formaDePagamento.pix);
  }

  obtenhaLabelPagamentoOnline(formaDePagamento: any): string {
    return this.ehPixOnline(formaDePagamento) ? 'PIX' : 'Cartão Crédito Online';
  }

  obtenhaDescricaoPagamentoOnline(formaDePagamento: any): string {
    return this.ehPixOnline(formaDePagamento)
      ? 'Link com QR Code para o cliente no Pix'
      : 'Link para o cliente pagar no cartão';
  }

  novoValorPagar(novoTotal: number){
    const totalAnterior = this.totalPagar;

    this.totalPagar = novoTotal;
    if(this.multiplasFormasPagamentos) {
      if(totalAnterior !== novoTotal)
        this.limpePagamentos();
    } else {
      let pagamento = this.obtenhaPagamentoUnico();

      if(pagamento) {
        pagamento.valor = this.totalPagar
        pagamento.taxa = 0;

        if(pagamento.formaDePagamento && pagamento.formaDePagamento.taxaCobranca)
          pagamento.setValorComTaxa(pagamento.formaDePagamento.taxaCobranca)
      }
    }
  }

  obtenhaPagamentoUnico(){
    return this.pagamentos.find((item: any) => !item.removido);
  }

  obtenhaErroPagamento(){
    if(this.pixOnlineTunaSelecionado())
      return 'Gere o Pix ou selecione outra forma de pagamento';

    if(!this.frm.valid)   return ''

    if(!this.pagamentos.length)
      return  this.multiplasFormasPagamentos ? 'Adicione uma forma de pagamento ' : 'Defina uma forma de pagamento ';

    const totalPago = this.obtenhaTotalPagoSemTaxa();
    const diferenca = Number((this.totalPagar - totalPago).toFixed(2));

    if(diferenca > 0) {
      return 'Ainda falta adicionar R$ ' + diferenca.toFixed(2) + ' no pagamento'
    }

    if(diferenca < 0)
      return 'Valor do pagamento maior que o total a pagar em R$ ' + Math.abs(diferenca).toFixed(2)

    return null;
  }

  obtenhaTotalPagoSemTaxa(){
    let totalPago = 0.0;

    for(let pagamento of this.pagamentos) {
      if(pagamento.removido) continue;

      totalPago += pagamento.valor || 0;
      if(pagamento.taxa) totalPago -= pagamento.taxa;
    }

    return Number(totalPago.toFixed(2));
  }

  calculeTroco() {
    this.troco = 0;

    if (this.pagarEmDinheiro() ) {
      if(this.multiplasFormasPagamentos)
        this.troco = Number (( this.formaDePagamentoEscolhida.valor - this.obtenhaValorRestante()).toFixed(2));
      else{
        let pagamento = this.obtenhaPagamentoUnico();

        if(this.trocoPara){
          pagamento.trocoPara = this.trocoPara;
          this.troco =   Number( (this.trocoPara - pagamento.valor).toFixed(2))
        }
      }


      if (this.troco < 0) this.troco = 0;

    }
  }


  mudouMultiplasFormas() {
     //if(this.pagamentos.length > 1)
     this.limpePagamentos();

    this.alterouOpcaoMultiplasFormas.emit()
  }

  setPagamentos(pagamentos: Array<Pagamento>) {
    this.pagamentos = pagamentos;

    this.multiplasFormasPagamentos = this.pagamentos.filter((item: any) => !item.removido).length > 1;

    if(!this.multiplasFormasPagamentos){
      let pagamento   =  this.obtenhaPagamentoUnico();

      if(pagamento){
        pagamento.valor = this.totalPagar;
        this.formaDePagamentoEscolhida =
          this.formasDePagamento.find((item: any) => item.id === pagamento.formaDePagamento.id);

        if(    pagamento.trocoPara) {
          this.trocoPara = pagamento.trocoPara
          this.temTroco = 'sim' ;
          this.calculeTroco()
        }
      }
    }
  }

  mudouOpcaoParaSemTroco() {
    this.temTroco = "nao";
    for( let pagamento of this.pagamentos )
    {
      pagamento.trocoPara = 0;
      pagamento.troco = 0;
    }
    this.trocoPara = 0;
  }

  mudouOpcaoComTroco(){
    this.temTroco = "sim";
  }

  formasDePagamentoNaEntrega() {
     return this.formasDePagamento.filter((item: any) => item.id && !item.online)
  }
}
